import { render, staticRenderFns } from "./caseShare.vue?vue&type=template&id=55c152fe&scoped=true&"
import script from "./caseShare.vue?vue&type=script&lang=js&"
export * from "./caseShare.vue?vue&type=script&lang=js&"
import style0 from "./caseShare.vue?vue&type=style&index=0&id=55c152fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c152fe",
  null
  
)

export default component.exports